import { getVar } from "@fckdtl/themotion/helpers/cssVars";

import { baseline } from "./config";
import colors from "./domains/colors";
import fonts from "./domains/fonts";
import grid from "./domains/grid";
import spaces from "./domains/spacing";
import breakpoints from "./domains/breakpoints";

const adpativeText = (responsiveStyles, breakpoints) => {
  return ``;
};

const input = [breakpoints, colors, fonts, grid, spaces];

const d = input.reduce(
  (acc, cur) => ({
    ...acc,
    [cur.config.domain]: cur.map,
  }),
  {}
);

const base = {
  vars: input
    .filter((i) => !!i.config.createCssVariables)
    .map((i) => ({ prefix: i.config.domain, vars: i.vars })),
  styles: {
    body: `
      color: $color-text;
      background: $color-bg;
      font-family: $font-text;
      font-weight: normal;
      overflow-x: hidden;
      margin: 0 0 0 10px;

      * {
        margin: 0;
      }
      @media:xl {
        margin-left: 80px; 
      }
      `,
    "h1, h2, h3, h4, h5, h6": `
      font-family: $font-headline;
    `,
    "#___gatsby": `
      overflow: hidden;
    `,
  },
};

const uiStyles = {
  text: `
  padding: 1px 0;
  &:before, &:after {
    content: "";
    display: block;
  }
  `,
  textHeadline: `
    position:relative;
    top: 0;
    left: -0.08em;
    font-family: $font-headline;
    font-weight: normal;
    color: $color-spot1;
  `,

  textH1: `
    letter-spacing: -0.015625em;
    font-size: {35,35,,,,96}({"step": 1, "method": "floor"})px;
    line-height: {40,40,,,,104}({"step": 8, "method": "ceil"})px;
    ${adpativeText({
      size: {
        scale: [35, 35, , , , 96],
        step: 1,
        method: "floor",
      },
      line: {
        scale: [40, 40, , , , 104],
        step: baseline,
      },
    })}
  `,
  textH2: `
    font-size: {32,32,,,,60}({"step": 1, "method": "floor"})px;
    line-height: {40,40,,,,72}({"step": 8, "method": "ceil"})px;
  `,
  textH3: `
  font-size: {28,28,,,,48}({"step": 1, "method": "floor"})px;
  line-height: {36,36,,,,56}({"step": 8, "method": "ceil"})px;
  `,
  textH4: `
  font-size: {25,25,,,,34}({"step": 1, "method": "floor"})px;
  line-height: {36,36,,,,48}({"step": 8, "method": "ceil"})px;
  `,
  textH5: `
    font-size: 24px;
    line-height: 24px;
  `,
  textH6: `
    font-size: 20px;
    line-height: 24px;
  `,
  textSubtitle1: `
    font-family: $font-subline;
    font-weight: 400;
    letter-spacing: 0.0094em;

    font-size: {10,10,,,,18}({"step": 1, "method": "floor"})px;
    line-height: {16,16,,,,24}({"step": 8, "method": "ceil"})px;
  `,
  textSubtitle2: `
    font-family: $font-subline;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.0094em;
  `,
  textBody: `
  font-family: $font-text;
  font-weight: 400;
  letter-spacing: 0.014em;
  `,
  textBody1: `
  font-size: {14,14,,,,18}({"step": 1, "method": "floor"})px;
  line-height: {24,24,,,,32}({"step": 8, "method": "round"})px;
  `,
  textBody2: `
    font-size: 18px;
    line-height: 32px;
  `,
  textButton: `
  font-family: $font-headline;
  font-weight: 400;
    font-size: 18px;
    line-height: 16px;
    letter-spacing: 0.0144em;
  `,
  textCaption: `
    font-family: $font-interface;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    letter-spacing: 0.00833em;
  `,
  textOverline: `
    color: $color-spot1;
    font-family: $font-interface;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.15em;
    text-transform: uppercase;
  `,
  layerCard: `
    background: $color-bg2;
  `,
  layerBorder: `
  border: solid 1px $color-spot1;
  border-radius: 50px;
  &:focus {
    outline: none;
    box-shadow: 0 0 8px rgba($color-spot2, .6);
  }
  `,
};

const utils = {
  styles: input.reduce((acc, cur) => {
    if (!cur.styles) {
      return acc;
    }
    return {
      ...acc,
      ...cur.styles,
    };
  }, {}),
};

export default {
  definitions: { ...d },
  base,
  ui: {
    ...uiStyles,
  },
  utils,
};
